import styled from 'styled-components';

const Wrapper = styled.div`
  position: fixed;
  bottom: 0px;
  width: 100%;
  justify-content: 'center';
  text-align: 'center';
  align-items: 'center';
  margin: 50px auto 40px;
`;

const CenteredText = styled.div`
  position: relative;
  max-width: 600px;
  justify-content: 'center';
  text-align: 'center';
  align-items: 'center';
  background-color: cyan;
  margin: 0 auto;
`;

const Footer = () => {
  return (
    <Wrapper>
      <CenteredText>
        <marquee direction="left" scrollamount="10">
         Salacious Salamis send me salivating.
        </marquee>
      </CenteredText>
    </Wrapper>
  );
}

export default Footer;
